const t = "styles-module__splitDateInputWrapper___r20q6", e = "styles-module__splitDateInput___pVpYo", p = "styles-module__error___59zeT", s = {
  splitDateInputWrapper: t,
  splitDateInput: e,
  error: p
};
export {
  s as default,
  p as error,
  e as splitDateInput,
  t as splitDateInputWrapper
};
